import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core'
import { MatrixServices, SharedServices } from '@app/services'
import Constants from '@commons/Constants'
import { getImageRedirectUrl, handleImageError, imageUrl } from '@helpers/common'

@Component({
    selector: 'app-show-big-image',
    templateUrl: './show-big-image.component.html',
    styleUrls: ['./show-big-image.component.css'],
})
export class ShowBigImageComponent implements OnInit {
    @Input() wrapStyle: any
    @Output() _onShowed: EventEmitter<any> = new EventEmitter()
    @Output() _onClose: EventEmitter<any> = new EventEmitter()
    @Input() type = 'medium'
    @Input() forMobile: boolean = false

    @ViewChild('wrapImage') wrapImage: ElementRef
    @ViewChild('currentImage') currentImage: ElementRef

    urlBigImage: string
    isShow = false
    loading = false
    matrix: string
    imageId = ''
    initType = ''
    styleResponsiveBigImage: { transform: string }
    base64Image

    constructor(
        private _sharedService: SharedServices,
        public matrixServices: MatrixServices,
    ) {
    }

    ngOnInit() {
        this._sharedService.showBigImageEmitted$.subscribe((data) => {
            if (data) {
                console.debug('showBigImageEmitted$', data)
                this.urlBigImage = ''

                if (data.imageSrc) {
                    this.urlBigImage = data.imageSrc
                    const urlSerializer = new URL(this.urlBigImage)
                    if (urlSerializer.searchParams.has('type')) {
                        this.type = urlSerializer.searchParams.get('type')
                    }
                }
                this.showImage(data.id, data.matrix)
            }
        })
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        if (this.currentImage && this.wrapImage) {
            this.responsiveImage(
                this.currentImage.nativeElement,
                this.wrapImage.nativeElement,
                this.matrix,
            )
        }
    }

    showImage(imageId, matrix) {
        this.imageId = imageId
        this.isShow = true
        this.loading = true
        console.debug('showImage', imageId, matrix)
        setTimeout(() => {
            if (!this.urlBigImage) {
                this.urlBigImage = getImageRedirectUrl(imageUrl)
            }
            this.matrix = matrix ? matrix : Constants.IMAGE_MATRIX_DEFAULT
            setTimeout(() => {
                this.loading = false
                console.debug('showed')
                this._onShowed.emit(true)
            }, 200)
        }, 300)
    }

    hiddenBigImage() {
        this.isShow = false
        this._onClose.emit(true)
    }

    handleError() {
        setTimeout(() => {
            const urlBigImage = handleImageError(this.urlBigImage)
            if (urlBigImage) {
                this.urlBigImage = urlBigImage
            }
        }, 500)
    }

    async increaseQuality() {
        if (this.type === '' || this.type === 'medium') {
            console.group('increaseQuality')
            const xLargeUrl = await this.imageExists('xlarge')
            if (xLargeUrl) {
                console.debug('Loaded X-large')
                this.type = 'xlarge'
                this.urlBigImage = xLargeUrl
            } else {
                const largeUrl = await this.imageExists('large')
                if (largeUrl) {
                    console.debug('Loaded large')
                    this.type = 'large'
                    this.urlBigImage = largeUrl
                } else {
                    console.debug('No increase quality')
                }
            }
            console.groupEnd()
        }
    }

    toPureRotation(n1, n2, n3, n4) {
        if ((n2 != (-1 * n3)) ||
            (n4 != n1) ||
            ((n1 * n4 - n3 * n2) != 1)
        ) {
            return Number.NaN
        } else {
            return Math.acos(n1) * 180 / Math.PI // For degrees
        }
    }

    responsiveImage(currentImage, wrapImage, matrix) {
        const rotate = this.toPureRotation(matrix[0], matrix[1], matrix[2], matrix[3])
        let widthRatio = wrapImage.offsetWidth / currentImage.clientWidth
        let heightRatio = wrapImage.offsetHeight / currentImage.clientHeight

        if ((rotate % 90) % 2 === 0 && rotate !== 0) {
            widthRatio = wrapImage.offsetWidth / currentImage.clientHeight
            heightRatio = wrapImage.offsetHeight / currentImage.clientWidth
        }
        let ratioMin = widthRatio < heightRatio ? widthRatio : heightRatio
        const n1 = ratioMin * matrix[0] // n1
        const n2 = ratioMin * matrix[1] // n2
        const n3 = ratioMin * matrix[2] // n3
        const n4 = ratioMin * matrix[3] // n4
        const n5 = (wrapImage.offsetWidth - currentImage.clientWidth) / 2
        const n6 = (wrapImage.offsetHeight - currentImage.clientHeight) / 2

        this.styleResponsiveBigImage = {
            transform:
                'matrix(' +
                n1 +
                ', ' +
                n2 +
                ', ' +
                n3 +
                ', ' +
                n4 +
                ',' +
                n5 +
                ',' +
                n6 +
                ')',
        }
    }

    imageExists(type = ''): Promise<string> {
        return new Promise((resolve) => {
            let url = imageUrl + this.imageId + `?type=${ type }`
            const img = new Image()
            img.onload = function() {
                console.debug('image exist', type)
                resolve(url)
            }
            img.onerror = function() {
                console.debug('image do not exist', type)
                resolve('')
            }
            img.src = url
        })
    }
}



// WEBPACK FOOTER //
// ./src/app/commons/show-big-image/show-big-image.component.ts